import { defineAsyncComponent } from 'vue';

const CreateEstimateInitialPopup = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/popup/CreateEstimateInitialPopup.vue'),
);

const BaseEstimateInitialPopup = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/base/BaseEstimateInitialPopup.vue'),
);


const BaseEstimateInitialSectorWidePopup = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/estInitial/base/BaseEstimateInitialSectorWidePopup.vue'),
);

const SelectionEstimateInitialSectorWideRevenueBusinessPopup = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/estInitial/popup/SelectionEstimateInitialSectorWideRevenueBusinessPopup.vue'),
);

const SelectionEstimateInitialRevenueBusinessPopup = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/popup/SelectionEstimateInitialRevenueBusinessPopup.vue'),
);
const SubmitEstimateInitialPopup = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/popup/SubmitEstimateInitialPopup.vue'),
);

const EstimateInitialBusinessFeesAddRegularPopup = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/popup/EstimateInitialBusinessFeesAddRegularPopup.vue'),
);

const EstimateInitialSectorWideFeesAddRegularPopup = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/estInitial/popup/EstimateInitialSectorWideFeesAddRegularPopup.vue'),
);


const EstInitialSourcePopup = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/popup/EstInitialSourcePopup.vue'),
);

const SummaryEstInitialBaseDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/summary/SummaryEstInitialBaseDetail.vue'),
);

const SummaryEstInitialRevenueBusinessDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/summary/SummaryEstInitialRevenueBusinessDetail.vue'),
);
const SummaryEstInitialExpenseBusinessDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/summary/SummaryEstInitialExpenseBusinessDetail.vue'),
);
const SummaryEstInitialExpenseFeesDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/summary/SummaryEstInitialExpenseFeesDetail.vue'),
);
const SummaryEstInitialProjectDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/summary/SummaryEstInitialProjectDetail.vue'),
);
const SubmitEstInitialDetailPopup = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/submitEstInitial/SubmitEstInitialDetailPopup.vue'),
);
const SummaryEstInitialRegularDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/summary/SummaryEstInitialRegularDetail.vue'),
);

const SubmitEstInitialReturnExpenseFeesDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/return/SubmitEstInitialReturnExpenseFeesDetail.vue'),
);

const SubmitEstInitialReturnRevenueFeesDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/return/SubmitEstInitialReturnRevenueFeesDetail.vue'),
);

const SubmitEstInitialReturnRevenueBusinessDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/return/SubmitEstInitialReturnRevenueBusinessDetail.vue'),
);

const SubmitEstInitialReturnExpenseBusinessDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/return/SubmitEstInitialReturnExpenseBusinessDetail.vue'),
);

const SubmitEstInitialReturnRegularDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/return/SubmitEstInitialReturnRegularDetail.vue'),
);

const SubmitEstInitialReturnProjectDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/return/SubmitEstInitialReturnProjectDetail.vue'),
);

const SubmitSummaryEstInitialExpenseFeesDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/summary/SubmitSummaryEstInitialExpenseFeesDetail.vue'),
);
const SubmitSummaryEstInitialProjectDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/summary/SubmitSummaryEstInitialProjectDetail.vue'),
);
const SubmitSummaryEstInitialRegularDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/summary/SubmitSummaryEstInitialRegularDetail.vue'),
);

const SubmitSummaryEstInitialRevenueBusinessDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/summary/SubmitSummaryEstInitialRevenueBusinessDetail.vue'),
);
const SubmitSummaryEstInitialExpenseBusinessDetail = defineAsyncComponent(() =>
  import('@/views/estimate/estInitial/summary/SubmitSummaryEstInitialExpenseBusinessDetail.vue'),
);

const ImplementationTrackingDeletePopup = defineAsyncComponent(() =>
  import('@/views/implementationTracking/ImplementationTrackingDeletePopup.vue'),
);

const SummaryAuditEstInitialRevenueFeesDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryEstInitial/SummaryEstInitialRevenueFeesDetail.vue'),
);

const SummaryAuditEstInitialExpenseFeesDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryEstInitial/SummaryEstInitialExpenseFeesDetail.vue'),
);

const SummaryAuditEstInitialExpenseBusinessDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryEstInitial/SummaryEstInitialExpenseBusinessDetail.vue'),
);

const EstInitialSectorWideRegularExplanationPopup = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/estInitial/popup/EstInitialSectorWideRegularExplanationPopup.vue'),
);

const EstimateInitialSectorWideAddRegularPopup = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/estInitial/popup/EstimateInitialSectorWideAddRegularPopup.vue'),
);

const EstInitialSectorWideExplanationSalaryDetailPopup = defineAsyncComponent(() =>
  import('@/views/estimateSectorWide/estInitial/popup/EstInitialSectorWideExplanationSalaryDetailPopup.vue'),
);

const SummaryAuditEstInitialRevenueBusinessDetail = defineAsyncComponent(() =>
  import('@/views/summaryEstimate/summaryEstInitial/SummaryEstInitialRevenueBusinessDetail.vue'),
);

const EstInitialAggregateExplanationFormSalaryDetailPopup = defineAsyncComponent(() =>
  import('@/views/estInitialAggregate/popup/EstInitialAggregateExplanationFormSalaryDetailPopup.vue'),
);

const SubmitEstimateAggregateInitialPopup = defineAsyncComponent(() =>
  import('@/views/estInitialAggregate/popup/SubmitEstimateAggregateInitialPopup.vue'),
);

export function estimateInitialRegister(app) {
  app.component('CreateEstimateInitialPopup', CreateEstimateInitialPopup);
  app.component('BaseEstimateInitialPopup', BaseEstimateInitialPopup);
  app.component('BaseEstimateInitialSectorWidePopup', BaseEstimateInitialSectorWidePopup);
  app.component('SelectionEstimateInitialSectorWideRevenueBusinessPopup', SelectionEstimateInitialSectorWideRevenueBusinessPopup);
  app.component('SelectionEstimateInitialRevenueBusinessPopup', SelectionEstimateInitialRevenueBusinessPopup);
  app.component('SubmitEstimateInitialPopup', SubmitEstimateInitialPopup);
  app.component('EstimateInitialBusinessFeesAddRegularPopup', EstimateInitialBusinessFeesAddRegularPopup);
  app.component('EstimateInitialSectorWideFeesAddRegularPopup', EstimateInitialSectorWideFeesAddRegularPopup);
  app.component('EstInitialSourcePopup', EstInitialSourcePopup);
  app.component('SummaryEstInitialBaseDetail', SummaryEstInitialBaseDetail);
  app.component('SummaryEstInitialRevenueBusinessDetail', SummaryEstInitialRevenueBusinessDetail);
  app.component('SummaryEstInitialExpenseBusinessDetail', SummaryEstInitialExpenseBusinessDetail);
  app.component('SummaryEstInitialExpenseFeesDetail', SummaryEstInitialExpenseFeesDetail);
  app.component('SummaryEstInitialProjectDetail', SummaryEstInitialProjectDetail);
  app.component('SubmitEstInitialDetailPopup', SubmitEstInitialDetailPopup);
  app.component('SummaryEstInitialRegularDetail', SummaryEstInitialRegularDetail);
  app.component('SubmitEstInitialReturnExpenseFeesDetail', SubmitEstInitialReturnExpenseFeesDetail);
  app.component('SubmitEstInitialReturnRevenueFeesDetail', SubmitEstInitialReturnRevenueFeesDetail);
  app.component('SubmitEstInitialReturnRevenueBusinessDetail', SubmitEstInitialReturnRevenueBusinessDetail);
  app.component('SubmitEstInitialReturnExpenseBusinessDetail', SubmitEstInitialReturnExpenseBusinessDetail);
  app.component('SubmitEstInitialReturnRegularDetail', SubmitEstInitialReturnRegularDetail);
  app.component('SubmitEstInitialReturnProjectDetail', SubmitEstInitialReturnProjectDetail);
  app.component('SubmitSummaryEstInitialExpenseFeesDetail', SubmitSummaryEstInitialExpenseFeesDetail);
  app.component('SubmitSummaryEstInitialProjectDetail', SubmitSummaryEstInitialProjectDetail);
  app.component('SubmitSummaryEstInitialRegularDetail', SubmitSummaryEstInitialRegularDetail);
  app.component('SubmitSummaryEstInitialRevenueBusinessDetail', SubmitSummaryEstInitialRevenueBusinessDetail);
  app.component('SubmitSummaryEstInitialExpenseBusinessDetail', SubmitSummaryEstInitialExpenseBusinessDetail);
  app.component('ImplementationTrackingDeletePopup', ImplementationTrackingDeletePopup);
  app.component('SummaryAuditEstInitialRevenueFeesDetail', SummaryAuditEstInitialRevenueFeesDetail);
  app.component('SummaryAuditEstInitialExpenseFeesDetail', SummaryAuditEstInitialExpenseFeesDetail);
  app.component('SummaryAuditEstInitialExpenseBusinessDetail', SummaryAuditEstInitialExpenseBusinessDetail);
  app.component('EstInitialSectorWideRegularExplanationPopup', EstInitialSectorWideRegularExplanationPopup);
  app.component('EstInitialSectorWideExplanationSalaryDetailPopup', EstInitialSectorWideExplanationSalaryDetailPopup);
  app.component('SummaryAuditEstInitialRevenueBusinessDetail', SummaryAuditEstInitialRevenueBusinessDetail);
  app.component('EstInitialAggregateExplanationFormSalaryDetailPopup', EstInitialAggregateExplanationFormSalaryDetailPopup);
  app.component('SubmitEstimateAggregateInitialPopup', SubmitEstimateAggregateInitialPopup);
  app.component('EstimateInitialSectorWideAddRegularPopup', EstimateInitialSectorWideAddRegularPopup);
}
